import script from "./FinishStep.vue?vue&type=script&setup=true&lang=js"
export * from "./FinishStep.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__